import { Component, effect, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HlmTabsImports } from '@spartan-ng/helm/tabs';

import { EtapeStore } from '../../référentiel-métier-parcours/parcours-etape/store/etape.store';
import { ModuleStore } from '../../référentiel-métier-parcours/parcours-module/store/module.store';
import { BreadcrumbScenarisationComponent } from '../../shared/components/breadcrumb-scenarisation/breadcrumb-scenarisation.component';
import { HeaderCartographieComponent } from '../components/header-cartographie/header-cartographie.component';

@Component({
  selector: 'app-activite-layout',
  imports: [RouterModule, HlmTabsImports, BreadcrumbScenarisationComponent, HeaderCartographieComponent],
  templateUrl: './activite-layout.component.html',
})
export class ActiviteLayoutComponent {
  readonly #moduleStore = inject(ModuleStore);
  readonly #etapeStore = inject(EtapeStore);
  readonly moduleSelected = this.#moduleStore.selectedEntity;
  readonly links = [
    { label: 'Description', href: 'description' },
    { label: 'Parcours et objectif', href: 'parcours-objectif' },
    { label: 'Alternatives', href: 'alternatives' },
  ];

  activeTab = decodeURI(window.location.href.split('/').pop()?.split('?')[0] ?? '');

  constructor() {
    effect(() => {
      const module = this.moduleSelected();

      if (module) {
        this.#etapeStore.select({ id: module.idEtape });
      }
    });
  }
}
